<template>
  <div id="main_cont" class="container_j">
    <!-- TOP TABLECRUD BAR START -->
    <div class="toptoolbar d-flex align-items-center">
      <div style=" padding:10px; border-radius:10px; width:100%;" class="d-flex align-items-center">
        <div class="dropdown">
          <i
            class="fas fa-angle-down"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          ></i>

          <div
            class="dropdown-menu"
            aria-labelledby="dropdownMenuButton"
            style="z-index:999999 !important;"
          >
            <a class="dropdown-item" href="#">
              <i class="fas fa-list"></i> &nbsp;Prova prova
            </a>
            <a class="dropdown-item" href="#">
              <i class="fas fa-list"></i> &nbsp;Prova prova
            </a>
            <a class="dropdown-item" href="#">
              <i class="fas fa-list"></i> &nbsp;Prova prova
            </a>
          </div>
        </div>
        <div class="titolo_vista">{{$route.name}}</div>
        {{crudTableStates.length}}
        <div class="viewSwitch">
          <i
            :class="{ attivo : config.tableType === 'table'}"
            class="fas fa-list"
            @click="config.tableType = 'table'"
          ></i>
          <i
            :class="{ attivo : config.tableType === 'grid'}"
            class="fas fa-table"
            @click="config.tableType = 'grid'"
          ></i>
          <i
            :class="{ attivo : config.tableType === 'group'}"
            class="fas fa-object-group"
            @click="config.tableType = 'group'"
          ></i>
        </div>
      </div>
    </div>
    <thead
      v-if="config.tableType === 'table'"
      id="thead"
      :class="{ fixedTop: headerSettings.fixedTop }"
    >
      <crudTableHeader :columns="config.tableColumns" :tableType="config.tableType"></crudTableHeader>
    </thead>
    <tbody class="scroll-area" v-if="config.tableType === 'table'">
      <loaderSpinner v-if="!loaded" class="spinner_loading" :state="loaded"></loaderSpinner>
      <!--Vue perfect scrollbar interrompe il grado di parentela tra crudTable e crudRow e quindi devo
      fare bridge eventi con '@crudTableRowEvent="$emit('crudTableRowEvent',$event)"'-->
      <VuePerfectScrollbar
        @crudTableRowEvent="$emit('crudTableRowEvent',$event)"
        class="scroll-area"
        :settings="settings"
        @ps-y-reach-end
      >
        <crudTableRow
          v-for="trItem in crudTableStates"
          :key="trItem['.key']"
          :config="config"
          :trItem="trItem"
          :tableRowsConfig="config.tableRowsConfig"
          :tableType="config.tableType"
        ></crudTableRow>
        <!-- CONTEXTUAL MENU -->
      </VuePerfectScrollbar>
    </tbody>
    <!-- TABLE BUILDER END -->

    <tbody class="scroll-area" v-if="config.tableType === 'group'">
      <!--Vue perfect scrollbar interrompe il grado di parentela tra crudTable e crudRow e quindi devo
      fare bridge eventi con '@crudTableRowEvent="$emit('crudTableRowEvent',$event)"'-->
      <VuePerfectScrollbar
        @crudTableRowEvent="$emit('crudTableRowEvent',$event)"
        class="scroll-area"
        :settings="settings"
      >
        <crudTableRow
          v-for="trItem in crudTableStates"
          :key="trItem['.key']"
          :config="config"
          :trItem="trItem"
          :tableRowsConfig="config.tableRowsConfig"
          :tableType="config.tableType"
        ></crudTableRow>
        <!-- CONTEXTUAL MENU -->
      </VuePerfectScrollbar>
    </tbody>
    <!-- TABLE BUILDER END -->

    <!-- GRID BUILDER START -->
    <div v-if="config.tableType === 'grid'" class="grid-container">
      <VuePerfectScrollbar
        @crudTableRowEvent="$emit('crudTableRowEvent',$event)"
        class="scroll-area"
        id="PerfectScroll"
        :settings="settings"
        @ps-y-reach-end="showMore()"
      >
        <crudTableGridItem
          class="grid-item"
          v-for="trItem in crudTableStates"
          :key="trItem['.key']"
          :trItem="trItem"
          :gridItemConfig="config.gridItemConfig"
          :tableType="config.tableType"
        ></crudTableGridItem>
      </VuePerfectScrollbar>
    </div>
    <div class="moreRow">
      <i @click="showMore()" class="fas fa-angle-down"></i>
    </div>
    <!-- GRID BUILDER END -->
  </div>
</template>

<script>
//importare e registrare qui tutti i componenti child della tabella.(non in crudTableHeader/crudTableRow)
//NB : le operazioni crud a livello di database vanno collocate  direttamente nel componente child
//import { ref } from "@/components/puntatori";
import Vue from "vue";
import { jStore } from "../store/jestionaleStore.js";
//import { ref } from "@/components/puntatori";
import { mapState, mapGetters } from "vuex";
//MAIN TABLE COMPONENT IMPORT
import crudTableHeader from "@/components/crudTableHeader";
import crudTableRow from "@/components/crudTableRow";
import crudTableGridItem from "@/components/crudTableGridItem";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
//IMPORT WIDGET
import crudTableActionButton from "@/components/crudTableActionButton";
import crudTableQuantityWidget from "@/components/crudTableQuantityWidget";
import crudTableContextualMenu from "@/components/crudTableContextualMenu";
//OTHER UTILITY
import loaderSpinner from "@/components/loaderSpinner";
//MAIN TABLE COMPONENT DECRARATION
Vue.component("crudTableHeader", crudTableHeader);
Vue.component("crudTableRow", crudTableRow);
Vue.component("crudTableGridItem", crudTableGridItem);
//WIDGET DECRARATION
Vue.component("crudTableActionButton", crudTableActionButton);
Vue.component("crudTableQuantityWidget", crudTableQuantityWidget);
Vue.component("crudTableContextualMenu", crudTableContextualMenu);
//OTHER UTILITY
Vue.component("loaderSpinner", loaderSpinner);

export default {
  name: "crudTable",
  components: {
    VuePerfectScrollbar
  },
  computed: {
    //...mapGetters(["crudTableStates"])
    ...mapGetters({
      crudTableStates: "crudTableStates/tableRowsData",
      loaded: "crudTableStates/loaded",
      lastElement: "crudTableStates/lastElement"
    })
  },
  props: ["config"],
  data() {
    return {
      filters: {
        limitToFirst: 4,
        showMoreLimit: 3,
        lastTimeStamp: undefined
      },
      settings: {
        maxScrollbarLength: 50,
        suppressScrollX: true
      },
      headerSettings: {
        fixedTop: false
      }
    };
  },
  methods: {
    clickedCrudTableAction() {
      this.tableState.contextualMenu = {};
    },
    showMore: _.throttle(function() {
      if(this.filters.lastTimeStamp !== undefined){
      this.filters.lastTimeStamp = this.lastElement._timestamp + 1;
      }
      else {
        this.filters.limitToFirst = this.filters.limitToFirst * 2 
      }
    }, 1000)
  },
  mounted() {
    var self = this;
    this.filters.lastTimeStamp = undefined;
    var payload = {
      source: this.config.source,
      filters: this.filters
    };
    this.$store
      .dispatch("crudTableStates/getTableRowsData", payload)
      .then(user => {
        console.log("Caricamento " + payload.source + " completato");
        self.$store
          .dispatch("crudTableStates/newItemListener", payload)
          .then(user => {
            console.log("Listener nuovi " + payload.source + " creati");
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(err => {
        console.log(err);
      });
  },
  beforeDestroy() {
    var payload = {
      source: this.config.source
    };
    this.$store
      .dispatch("crudTableStates/destroyListeners", payload)
      .then(user => {
        console.log("Listeners precedenti distrutti.");
      })
      .catch(err => {
        console.log(err);
      });
  },
  watch: {
    filters: {
      handler() {
        var self = this;
        var payload = {
          source: this.config.source,
          filters: this.filters
        };
        this.$store
          .dispatch("crudTableStates/getTableRowsData", payload)
          .then(user => {
            console.log("Caricamento dati completato");
          })
          .catch(err => {
            console.log(err);
          });
      },
      deep: true
    },
    $route() {
      var obj = this.$route.query;
      Object.keys(obj).forEach(element => {
        console.log(element + "---" + obj[element]);
      });
    }
  }
};
</script>

<style scoped>
.container_j {
  position: relative;
  margin-left: 1.5vw;
  padding-right: 1.5vw;
}

.spinner_loading {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 999999;
}

.toptoolbar {
  height: 13vh;
  padding: 3vh;
}

.titolo_vista {
  font-size: 4vh;
  font-weight: bold;
  color: #565656;
  margin-left: 1vh;
  margin-right: 2vh;
}

.toptoolbar .dropdown > i {
  background-color: #949595;
  color: white;
  outline: none !important;
  border-radius: 50%;
  height: 2vh;
  width: 2vh;
  text-align: center;
  line-height: 2.3vh;
  font-size: 1em;
}

.toptoolbar .dropdown button:hover {
  background-color: #6c757d;
}

.toptoolbar .dropdown button:focus {
  outline: none !important;
}

.viewSwitch {
  color: #a3a3a4;
  font-size: 1em;
}

.viewSwitch i {
  padding: 1vh;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.viewSwitch i:hover {
  background-color: white !important;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.attivo {
  color: black;
  font-weight: bold;
}

thead {
  display: block;
  margin-bottom: 1vh;
  color: #6d6d6d;
}

.attivo {
  /*background-color: white !important;*/
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.scroll-area {
  height: 60vh;
}

tbody {
  display: block;
}

.moreRow {
  text-align: center;
  font-size: 3vh;
  width: 100%;
  height: 7vh;
  line-height: 7vh;
}

.moreRow i {
  cursor: pointer;
  background-color: #e9ecef;
  color: #039be5;
  line-height: 5vh;
  width: 5vh;
  height: 5vh;
  border-radius: 50%;
}

.moreRow i:hover {
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* STYLE PER VISUALIZZAZIONE A  GRID*/

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15vw, 18vw));
  list-style-type: none;
  padding: 0px;
  margin: 0px;
  grid-auto-rows: minmax(auto, 20vw);
  grid-gap: 25px;
}
.grid-item {
  transition: left 300ms, top 300ms;
  background-color: white;
  border-radius: 10px;
  border: solid 3px #f9f9f9;
  font-size: 14px;
}
</style>
